<div class="template-wrapper" *ngIf="!skeletonOnly">
  <p class="purpose" (click)="viewScanner()">
    {{ getTitle() }}
    <ion-icon *ngIf="showEditButton" name="create"></ion-icon>
  </p>
  <p class="anyone-note">Anyone can scan this QR to share their IDs with you</p>

  <div class="qr-wrapper" (click)="viewScanner()">
    <ion-skeleton-text animated="true" *ngIf="loading"></ion-skeleton-text>
    <qrcode [qrdata]="baseUrl + scanner.qr" [width]="180"></qrcode>
  </div>

  <p *ngIf="showCode" class="uni-code">{{ getUniqueCode(scanner?.qr) }}</p>

  <div
    class="copy-link-wrapper"
    *ngIf="showCopy"
    #copyButton
    (click)="copy(copyButton)">
    <ion-icon name="copy-outline"></ion-icon>
    Copy Shareable Link
  </div>

  <div class="bottom-button-wrapper">
    <button (click)="viewScanner()">
      <ion-icon name="share-outline"></ion-icon>
      Share QR
    </button>
  </div>
</div>

<div *ngIf="skeletonOnly" sxWidth="full" sxRadius="medium" sxBorderColor="one"
     sxBorderWidth="1px" sxCol sxAlign="center" sxDistribution="center" sxGap="15px" sxPadding="medium">

  <ion-skeleton-text sxMargin="15px 0 0" sxWidth="85px" sxHeight="18px" [animated]="true"></ion-skeleton-text>
  <ion-skeleton-text sxWidth="225px" sxHeight="12px" [animated]="true"></ion-skeleton-text>
  <ion-skeleton-text sxWidth="150px" sxHeight="150px" sxRadius="medium" [animated]="true"></ion-skeleton-text>
  <ion-skeleton-text sxWidth="85px" sxHeight="18px" [animated]="true"></ion-skeleton-text>
  <ion-skeleton-text sxWidth="full" sxHeight="40px" [animated]="true"></ion-skeleton-text>
</div>
